import {inject} from '@angular/core';
import {tap} from 'rxjs/operators';
import {HttpInterceptorFn, HttpRequest, HttpResponse} from '@angular/common/http';
import {AuthApiService} from '../../services/api/auth/auth-api.service';
import {ApiResponse} from '../../services/api/base-api.service';
import {SessionManagerService} from '../../services/shared/session-manager.service';
import {UserSession} from '../../models/session/user-session.interface';
import {isSessionExpired} from '../../shared/utils/api-response.util';

const COMMON_HEADERS: Record<string, string> = {
  Accept: 'application/json',
  'Accept-Language': 'es',
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthApiService);
  const sessionManager = inject(SessionManagerService);

  const user: UserSession | null = auth.getUserSession();

  const cloned: HttpRequest<unknown> = !auth.userIsLogIn() || !user
    ? req.clone({setHeaders: COMMON_HEADERS})
    : req.clone({
      setParams: {'user-key': String(user.id)},
      setHeaders: {...COMMON_HEADERS, Authorization: user.token},
    });

  return next(cloned).pipe(tap((evt) => {
    const body: ApiResponse | null = evt instanceof HttpResponse ? (evt.body as ApiResponse | null) : null;

    if (isSessionExpired(body)) {
      sessionManager.handleSessionExpired(true);
    }
  }));
};
